import { request, METHOD } from '@/utils/request'
const BASE_URL = process.env.VUE_APP_API_BASE_URL
// 获取工资列表
export async function getSalaryList(queryInfo) {
  return request('/salaryController/getSalaryList', METHOD.POST, {
    queryInfo: queryInfo
  })
}

// 保存工资记录
export async function saveSalary(salary) {
  return request('/salaryController/saveSalary', METHOD.POST, {
    salaryEntity: salary
  })
}

// 更新工资记录
export async function updateSalary(salary) {
  return request('/salaryController/updateSalary', METHOD.POST, {
    salaryEntity: salary
  })
}

// 删除工资记录
export async function deleteSalary(id) {
  return request('/salaryController/deleteSalary', METHOD.POST, {
    id: id
  })
}

// 根据ID获取工资详情
export async function getSalaryById(id) {
  return request('/salaryController/getSalaryById', METHOD.POST, {
    id: id
  })
}

// 更改工资状态
export async function changeSalaryStatus(salary) {
  return request('/salaryController/changeStatus', METHOD.POST, {
    salaryEntity: salary
  })
}

// 导入工资数据
export async function importSalaryData(formData) {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  const response = await fetch('/api/salaryController/importSalary', {
    method: 'POST',
    headers: {
      'Authorization': token
    },
    body: formData
  });
  
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error('Network error');
  }
}

// 下载工资总表模板
export async function downloadSalaryTemplate() {
  return request('/salaryController/downloadSalaryTemplate', METHOD.GET)
}

// 下载奖励性绩效明细表模板
export async function downloadPerformanceTemplate() {
  return request('/salaryController/downloadPerformanceTemplate', METHOD.GET)
}

// 获取工资导入记录列表
export async function getSalaryImportRecordList(params) {
  return request('/salaryController/getSalaryImportRecordList', METHOD.POST, params)
}

// 获取工资总表明细
export async function getSalaryTotalList(params) {
  return request('/salaryController/getSalaryTotalList', METHOD.POST, params)
}

// 获取奖励性绩效明细
export async function getSalaryDetailList(params) {
  return request('/salaryController/getSalaryDetailList', METHOD.POST, params)
}

// 导出工资总表明细
export async function exportSalaryTotalList(params) {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  
  const response = await fetch('/api/salaryController/exportSalaryTotalList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify(params)
  });

  if (response.ok) {
    return response.blob(); // Return the file as a blob
  } else {
    throw new Error('File export failed');
  }
}

// 导出奖励性绩效明细
export async function exportSalaryDetailList(params) {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  
  const response = await fetch('/api/salaryController/exportSalaryDetailList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify(params)
  });

  if (response.ok) {
    return response.blob(); // Return the file as a blob
  } else {
    throw new Error('File export failed');
  }
}

// 获取待发送人员数量
export async function getPendingSendCount(recordId) {
  return request('/salaryController/getPendingSendCount', METHOD.POST, {
    recordId: recordId
  })
}

// 获取所有待发送人员信息
export async function getPendingSendPersons(recordId) {
  return request('/salaryController/getPendingSendPersons', METHOD.POST, {
    recordId: recordId
  })
}

// 发送工资条通知
export async function sendSalaryNotice(params) {
  return request('/salaryController/sendSalaryNotice', METHOD.POST, params)
}








export async function importSalary(data) {
    return request(`${BASE_URL}/salary/import`, METHOD.POST, data)
}

export async function getSalaryHistory(params) {
   
    return request(`${BASE_URL}/salary/records`, METHOD.GET, params)
}

export async function getSalaryDetail(params) {
    return request(`${BASE_URL}/salary/detail`, METHOD.GET, params)
}

export async function getSalaryStatistics(data) {
    return request(`${BASE_URL}/salary/statistics/report`, METHOD.POST, data)
}

export async function exportSalary(data) {
    // 使用原生 fetch 绕过 MockJS 拦截
    // 注意：需要双重 /api 前缀以匹配 devServer 代理逻辑
    const token = Cookie.get('Authorization')
    const url = `${BASE_URL}${BASE_URL}/salary/export`
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(data)
    })
}

export async function setSalaryStatus(data) {
    return request(`${BASE_URL}/salary/setStatus`, METHOD.POST, data)
}
// export default {
//     importSalary,
//     getSalaryHistory,
//     getSalaryDetail,
//     getSalaryStatistics,
//     exportSalary,
//     setSalaryStatus
// }
